import { render, staticRenderFns } from "./CurrentBill.vue?vue&type=template&id=1be2d65a"
import script from "./CurrentBill.vue?vue&type=script&lang=js"
export * from "./CurrentBill.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports